<template>
  <div class="price-catalog py-9 bg-gray-100">
    <div class="wrapper" ref="anchorTop">
      <form>
        <transition name="fade-slide__y-100">
          <div v-if="startMounted" class="catalog-search mb-6">
            <div class="relative">
              <button class="absolute top-0 p-3 text-gray-400 focus:outline-none catalog-search__button catalog-search__button_search"
                      :disabled="!hasSearchQuery"
                      @click.prevent="search">
                <icon-base viewBox="0 0 14 14">
                  <icon-search/>
                </icon-base>
              </button>
              <input type="text"
                    class="w-full px-12 py-2 bg-transparent border border-gray-800 rounded-3xl focus:outline-none"
                    name="search"
                    v-model.trim="searchQuery"
                    placeholder="Поиск по названию">
              <button class="absolute top-0 p-3 text-gray-400 focus:outline-none catalog-search__button catalog-search__button_reset"
                      :class="{hidden : !hasSearchQuery}"
                      :disabled="!hasSearchQuery"
                      @click.prevent="resetSearch">

                <icon-base viewBox="0 0 20 20" width="14" height="14">
                  <icon-cross/>
                </icon-base>
              </button>
            </div>
          </div>
        </transition>
        <div>
          <div class="relative flex flex-col lg:flex-row gap-3.5 lg:gap-5">
            <transition name="fade-slide__y-100">
              <div v-if="hasCategoriesList"
                   class="flex flex-col sticky z-10 top-15 lg:static lg:z-auto lg:top-0"
                   :style="{ top: offsetTop + 'px', transition: 'top 0.3s' }">
                <!--  меню категорий десктоп-->
                <div id="catalogNav"
                     class="hidden lg:block w-75 h-full flex-shrink-0 bg-white rounded-xl py-5 pl-5 pr-0.5"
                     :style="{
                       maxHeight: maxHeightCatalogNav + 'px',
                       minHeight: minHeightCatalogNav + 'px'
                     }">
                    <!--  дерево категорий-->
                  <div class="h-full overflow-y-auto pr-4">
                    <categories-list :categoriesList="categoriesList"
                                     :selectedCategory="selectedCategory"
                                     :is-root="true"
                                     @select-category="updateSelectedCategory"/>
                  </div>
                </div>
                <!--  dropdown с категориями мобилка -->
                <div class="catalog-dropdown lg:hidden">
                  <dropdown ref="dropdownMenuCategories">
                    <template #button>
                      <button class="h-14 w-full flex items-center bg-white rounded-xl text-primary-bright shadow-gray-250 focus:outline-none"
                              @click.prevent="">
                        <div class="flex flex-shrink-0 w-14 h-full border-r border-purple-100">
                          <icon-base viewBox="0 0 28 28" width="28" height="28" class="m-auto">
                            <icon-list></icon-list>
                          </icon-base>
                        </div>
                        <div class="pl-3 truncate text-16/20 font-semibold">
                          {{selectedCategory && selectedCategory.name || 'Выберите категорию' }}
                        </div>
                        <div class="catalog-dropdown__button-append-icon flex flex-shrink-0 w-14 h-full ml-auto transform transition-transform duration-500">
                          <icon-base viewBox="0 0 14 12" width="14" height="12" class="m-auto">
                            <icon-sort-down></icon-sort-down>
                          </icon-base>
                        </div>
                      </button>
                    </template>
                    <template #list>
                      <div class="mt-2 px-3 pt-5 pb-3 bg-white rounded-xl shadow-gray-250">

                        <div class="pr-5 h-105 overflow-y-scroll">
                          <categories-list :categoriesList="categoriesList"
                                           :selectedCategory="selectedCategory"
                                           :is-root="true"
                                           @select-category="updateSelectedCategory"/>
                        </div>
                      </div>
                    </template>
                  </dropdown>
                </div>
              </div>
            </transition>

            <div class="service-menu">
              <div id="servicesMenu"
                   ref="servicesMenu">
                <div class="service-menu__caption">
                  <transition-group name="fade-slide__y-100" appear>
                    <div v-if="hasSearchQuery" class="service-menu__title">
                      <div class="flex items-center">
                        <p class="mr-2">
                          Результаты поиска
                          <span v-if="hasCurrentCategory">
                            по разделу
                            <span class="font-bold">
                              "{{ currentCategory.tree_path_str }}"
                            </span>
                          </span>
                          <span v-if="hasServicesList && !loading">
                             -&nbsp;{{ totalCountServices }}&nbsp;шт.
                          </span>
                        </p>
                      </div>
                    </div>
                    <!-- ссылка на выбранную категорию -->
                    <div v-else-if="selectedCategory && hasCategoriesList"
                         class="service-menu__title hidden lg:block">
                      <a :href="selectedCategory.url"
                         class="flex items-center link-text-primary">
                        <p class="mr-2">{{ selectedCategory.name }}
                          <span class="inline-block min-w-8"> ({{ totalCountServices }})</span>
                        </p>
                        <icon-base viewBox="0 0 5 8" width="12">
                          <icon-chevron-right/>
                        </icon-base>
                      </a>
                    </div>
                    <!--версия с кнопкой для перехода в категорию-->
<!--                    <div v-else-if="selectedCategory && hasCategoriesList" class="service-menu__title hidden lg:flex w-full items-center justify-between">-->
<!--                      <p class="mr-2">{{ selectedCategory.name }}-->
<!--                        <span class="inline-block min-w-8"> ({{ totalCountServices }})</span>-->
<!--                      </p>-->
<!--                      <a :href="`/categories/${selectedCategory.id}`"-->
<!--                         class="px-8 z-1 button-md font-medium lg:font-semibold bg-white button-border-primary">-->
<!--                        Узнать подробнее-->
<!--                      </a>-->
<!--                    </div>-->
                  </transition-group>
                </div>

                <div class="service-menu__body">
                  <p v-if="error" class="text-center text-base text-gray-400 mt-10">
                    Возникли ошибки при загрузке данных: {{ error }}
                  </p>
                  <transition-group v-else-if="hasServicesList"
                                    tag="ul"
                                    name="fade-slide__y-100"
                                    appear
                                    class="space-y-3.5 relative">
                    <services-item
                        v-for="service in servicesList"
                        :key="service.id"
                        :service="service"
                        :categoryId="selectedCategory ? selectedCategory.id : null"
                    />
                  </transition-group>
                  <p v-else-if="loading"
                     class="text-center text-base text-gray-400 mt-10">
                    Загружаю услуги...
                  </p>
                  <p v-else
                     class="text-center text-base text-gray-400 mt-10">
                    {{ hasSearchQuery ? `По запросу "${searchQuery}" - ничего не найдено.` : 'Услуги в данной категории отсутствуют.' }}
                  </p>
                </div>
              </div>
            </div>
          </div>
            <!-- пагинация-->
          <div class="my-6 lg:h-9 flex justify-center"
               :class="{'lg:ml-80': hasCategoriesList}">
              <pagination
                  :current-page="currentPage"
                  :total-pages="totalPages"
                  @update:current-page="updateCurrentPage"
              ></pagination>
          </div>
          <div v-if="selectedCategory && hasCategoriesList" class="lg:hidden mt-9">
            <a :href="selectedCategory.url"
               class="button-md w-full button-border-gray-650 font-medium">
              Узнать подробнее
            </a>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import IconBase from "../icons/IconBase.vue";
import IconSearch from "../icons/IconSearch.vue";
import IconChevronRight from "../icons/IconChevronRight.vue";
import CategoriesList from "./CategoriesList.vue";
import Dropdown from "../ui/Dropdown.vue";
import Pagination from "../ui/Pagination.vue";
import IconCross from "../icons/IconCross.vue";
import ServicesItem from "./ServicesItem.vue";
import {getCategoryTree, getAvailableServices, searchServices} from "../../../plugins/api";
import IconList from "../icons/IconList.vue";
import IconSortDown from "../icons/IconSortDown.vue";

// в компонент передается id - текущей категории
// в зависимости от текущей категории логика отрисовки списка категорий
// - если категория конечная - нет дочерних подкатегорий - отображается только список услуг, дерево категорий отсутствует
// - если есть подкатегории - выводится дерево категорий и список услуг выбраноой категории
// - если текущая категория не указана - выводятся все категории и список услуг выбранной категории
export default {
  components: {
    ServicesItem,
    Pagination,
    CategoriesList,
    Dropdown,
    IconChevronRight,
    IconSearch,
    IconCross,
    IconSortDown,
    IconList,
    IconBase
  },
  props: {
    categoryId: {
      type: [Number, String],
      default: ''
    },
  },
  data() {
    return {
      currentCategory: null,
      selectedCategory: null,
      previousCategory: null,
      searchQuery: '',
      searchTimerId: null,
      categoriesList: [],
      servicesList: [],
      totalCountServices: 0,
      totalPages: 1,
      currentPage: 1,
      minHeightCatalogNav: 750,
      maxHeightCatalogNav: 750,
      loading: false,
      error: null,
      startMounted: false,
      offsetTop: 0
    }
  },
  computed: {
    hasCurrentCategory() {
      return Boolean(this.currentCategory)
    },
    hasCategoriesList() {
      return this.categoriesList && this.categoriesList.length > 0
    },
    hasServicesList() {
      return this.servicesList && this.servicesList.length > 0
    },
    hasSearchQuery() {
      return Boolean(this.searchQuery)
    },
  },
  watch: {
    selectedCategory(newValue) {
      if (Boolean(newValue)) {
        this.previousCategory = this.selectedCategory
        this.searchQuery = ''
        if (this.currentPage === 1) {
          this.getServices()
        } else {
          this.currentPage = 1
        }
      }
    },

    currentPage() {
      if (this.hasSearchQuery) {
        this.search()
      } else {
        this.getServices()
      }
    },

    searchQuery(newValue) {
      clearTimeout(this.searchTimerId); // Отменить предыдущий таймер
      if (newValue && newValue.length > 0) {
        this.searchTimerId = setTimeout(() => {
          this.selectedCategory = null
          if (this.currentPage === 1) {
            this.search()
          } else {
            this.currentPage = 1
          }
        }, 500);
      } else {
        // если параметры поиска сбошены - возвращаем ранее выбранную категорию
        this.selectedCategory = this.previousCategory
      }
    },
  },

  methods: {
    async getCategories() {
      this.error = null
      this.loading = true
      try {
        const data = await getCategoryTree({category_id: this.categoryId })
        this.categoriesList = data.categories;
        this.currentCategory = data.current_category;
      } catch (error) {
        this.error = error
      } finally {
        this.loading = false
      }
    },

    async getServices() {
      this.error = null
      this.loading = true
      try {
        const queryParams = {
          category_id: this.selectedCategory.id,
          page: this.currentPage,
        }
        const data = await getAvailableServices(queryParams)
        this.servicesList = data.services
        this.totalCountServices = data.total_count
        this.totalPages = data.total_pages
      } catch (error) {
        this.error = error
      } finally {
        this.loading = false
      }
    },

    async search() {
      this.error = null
      if (!this.hasSearchQuery) { return }

      this.loading = true
      try {
        const queryParams = {
          search: this.searchQuery,
          category_id: this.categoryId,
          page: this.currentPage,
        }
        const data = await searchServices(queryParams)
        this.servicesList = data.services
        this.totalCountServices = data.total_count
        this.totalPages = data.total_pages
      } catch (error) {
        this.error = error
      } finally {
        this.loading = false
      }
    },

    defaultSelectCategory() {
      if (this.hasCategoriesList) {
        this.selectedCategory = this.findCategoryNoChildren(this.categoriesList)
      } else {
        this.selectedCategory = this.currentCategory
      }
    },

    findCategoryNoChildren(categories) {
      // рекурсивная, находим первую по порядку категорию без детей
      for (const category of categories) {
        const childlessCategoryFound = category.children.length === 0 && !category.name.includes('Дополнительные')
        if (childlessCategoryFound) {
          return category
        } else {
          const childResult = this.findCategoryNoChildren(category.children)
          if (childResult) { return childResult }
        }
      }
      return null // Если не найдено категорий с пустым массивом children
    },

    updateSelectedCategory(category) {
      this.selectedCategory = category
      this.$refs.dropdownMenuCategories.close()
      this.scrollToTop()
    },

    updateCurrentPage(page) {
      this.currentPage = page
      this.scrollToTop()
    },

    updateMaxHeightCatalogNav() {
      // Устанавливает максимальную высоту списка категорий
      // не больше высоты списка услуг и не меньше миниимальной высоты списка категорий
      const servicesMenu = document.getElementById('servicesMenu');
      if (!servicesMenu) { return }
      
      const heightServicesMenu = servicesMenu.clientHeight;
      if (heightServicesMenu > this.minHeightCatalogNav) {
        this.maxHeightCatalogNav = heightServicesMenu;
      } else {
        this.maxHeightCatalogNav = Math.max(heightServicesMenu, this.minHeightCatalogNav);
      }
    },

    resetSearch() {
      this.searchQuery = ''
    },

    scrollToTop() {
      const element = this.$refs.anchorTop
      const headerHeight = document.getElementsByTagName('header')[0].offsetHeight
      const offsetTop = element.offsetTop - headerHeight //+ offset;
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });
    },
  },

  async created() {
    await this.getCategories()
    await this.defaultSelectCategory()
  },

  mounted() {
    this.startMounted = true
    this.$nextTick(() => {
      const servicesMenuElement = this.$refs.servicesMenu
      if (servicesMenuElement) {
        const resizeObserver = new ResizeObserver(() => {
          this.updateMaxHeightCatalogNav()
        })
        resizeObserver.observe(servicesMenuElement)
      }
    })
    const header = document.querySelector('header');
    const headerHeight = Math.round(header.getBoundingClientRect().height)
    const headerTopValue = Math.round(parseFloat(header.style.top))
    this.offsetTop = headerHeight + headerTopValue
    
    this.mutationObserver = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        const target = mutation.target
        const targetHeight = Math.round(target.getBoundingClientRect().height)
        const targetTopValue = Math.round(parseFloat(target.style.top))
        this.offsetTop = targetHeight + targetTopValue
      })
    })
    const config = { attributes: true, attributeFilter: ['style'] }
    this.mutationObserver.observe(header, config)
  },

  unmounted() {
    if (this.mutationObserver) { this.mutationObserver.disconnect() }
  }
}

</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.fade-slide__y-100-leave-active {
  transition: 0.4s ease all;
  position: absolute;
  z-index: 0;
}

.fade-slide__y-100-leave-to {
  opacity: 0;
}

.fade-slide__y-100-move {
  transition: 0.4s ease all;
}

.fade-slide__y-100-enter-from {
  opacity: 0;
  transform: translateY(100px);
}

.fade-slide__y-100-enter-active {
  transition: 0.7s ease all;
}
</style>